import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from '../services/auth.service';

/**
 * Guard for the login page that redirects to /uebersicht if the user is already
 * logged in. Use this guard ONLY on the /auth/login route.
 */
export const loggedInRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isLoggedIn().pipe(map(isLoggedIn => (isLoggedIn ? router.createUrlTree(['/uebersicht']) : true)));
};
